import * as React from 'react';
import { createComponent } from '@lit-labs/react';
import { ClbTableEmpty } from '@celebration/design-system/dist/lib/table-empty';

export default createComponent({
    react: React,
    elementClass: ClbTableEmpty,
    tagName: ClbTableEmpty.tagName,
    events: ClbTableEmpty.events,
});
